import React from "react";
import BlogEleven from "../component/BlogEleven";

function BlogElevenContainer() {
  return <BlogEleven />;
}
export default BlogElevenContainer;
